import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Title {
    constructor(){
        this.page = document.querySelector('.app-page');

        this.gallery = document.querySelector('.page-casestudies #gallery');

        this.title = {
            case: document.querySelector('.page-casestudies .page-title'),
        };
    }

    init(){
        this.manipulate();
        this.set();
        this.animation();
    }

    set = () => {
        gsap.set(this.title.case, {
            autoAlpha: 0,
            y: -50 + '%',
            x: -50 + '%',
        });
    }

    animation = () => {
        gsap.to(this.title.case, 2,{
            autoAlpha: .025,
            y: 12.5 + '%',
            ease: 'expo.easeInOut',
            scrollTrigger: {
                trigger: this.gallery,
                start: 'top top',
                end: 'bottom bottom',
                scrub: 3,
            }
        });
    }

    manipulate = () => {
        this.page.prepend(this.title.case);
    }
}
